module.exports = __webpack_public_path__ + "static/img/Frame 1819.8bd0630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/Frame 1819.jpg
// module id = olKJ
// module chunks = 12